import { Component, HostListener, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Platform, NavController, MenuController, LoadingController, AlertController } from '@ionic/angular';
import { AppVersion } from '@ionic-native/app-version/ngx';
import { CommonService } from 'src/app/common/common.service';

@Component({
  selector: 'app-landing-slider',
  templateUrl: './landing-slider.page.html',
  styleUrls: ['./landing-slider.page.scss'],
})
export class LandingSliderPage implements OnInit {
  slideOpts = {
    initialSlide: 0,
    speed: 400
  };
  slides = [];
  sliderDes: any = {};
  appName: string;
  Capture: string;
  mobile:boolean;
  appversionExisting:string;
  appversionRequired:string;
  link:string;
  user:any = null
  dataLoaded:boolean = false;
  ismobile:boolean;

  constructor(
    private platform: Platform,
    public navCtrl: NavController,
    private commonService: CommonService,
    public alertCtrl: AlertController,
    private loadingCtrl: LoadingController
  ) {

    this.commonService.ismobile.subscribe(ismobile => {
      this.ismobile = ismobile;
    })
    
    this.appName = environment.AppName;
    this.Capture = 'assets/imgs/' + this.appName + '/Capture.png';
    this.user = JSON.parse(localStorage.getItem('currentUser'));

    this.getBanners();
  }


  ngOnInit() {
    const loginType = localStorage.getItem('loginType');

    if(loginType === 'Admin'){
      this.navCtrl.navigateRoot('/home-admin');
      return false;
    }
    else if(loginType === 'Faculty'){
      this.navCtrl.navigateRoot('/home-faculty');
      return false;
    }
    else if(loginType === 'Demo'){
      this.navCtrl.navigateRoot('/home-demo');
    }
    else if(loginType === 'Student'){
      this.navCtrl.navigateRoot('/home');
    }
  }

  async getBanners(){
    const loading = await this.loadingCtrl.create({
      message: 'Please wait...',
    });
    await loading.present();
    
    this.commonService.getInstituteSlider().subscribe((resp) => {
      this.slides = resp.Items.reverse().slice(0,4);
      this.dataLoaded = true;
      loading.dismiss();
    });
  }

  goGames() {
    this.navCtrl.navigateForward('/dashboard');
  }
}
